var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E6E5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8017 18.3163C34.9596 17.944 35.3196 17.6985 35.724 17.6985H40.5709H45.4179C45.8223 17.6985 46.1823 17.944 46.3401 18.3163C46.3696 18.3858 46.4029 18.4633 46.4418 18.5525C46.7569 19.2756 47.1766 20.1496 47.7227 21.0078C48.8148 22.7242 50.5607 24.5306 53.0954 24.5306H57.219C57.7713 24.5306 58.219 24.9783 58.219 25.5306V40.4723C58.219 47.2346 55.132 52.3271 51.2986 56.0938C47.7887 59.5423 43.7167 61.7497 40.9529 62.9419C40.7083 63.0474 40.4335 63.0474 40.189 62.9419C37.4252 61.7497 33.3532 59.5423 29.8433 56.0938C26.0098 52.3271 22.9229 47.2346 22.9229 40.4723V25.5306C22.9229 24.9783 23.3706 24.5306 23.9229 24.5306H28.0465C30.5812 24.5306 32.327 22.7242 33.4192 21.0078C33.9653 20.1496 34.3849 19.2756 34.7001 18.5525C34.739 18.4633 34.7723 18.3858 34.8017 18.3163Z",
    fill: "white",
    stroke: "#8E8CEE",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7143 33.2186C42.7143 32.8217 42.3925 32.5 41.9956 32.5H40.0044C39.6075 32.5 39.2857 32.8217 39.2857 33.2186V38.7857H33.7186C33.3217 38.7857 33 39.1075 33 39.5044V41.4956C33 41.8925 33.3217 42.2143 33.7186 42.2143H39.2857V47.7814C39.2857 48.1783 39.6075 48.5 40.0044 48.5H41.9956C42.3925 48.5 42.7143 48.1783 42.7143 47.7814V42.2143H48.2814C48.6783 42.2143 49 41.8925 49 41.4956V39.5044C49 39.1075 48.6783 38.7857 48.2814 38.7857H42.7143V33.2186Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.6705732ef00311b9eaefdab398f82e35.svg";
export { ForwardRef as ReactComponent };